"use client";
import Image from "next/image";
import Link from "next/link";
import { Badge, Button, Input, List, Affix, AutoComplete } from "antd";
import { useState, useEffect, useMemo, useRef } from "react";
import { Login } from "@/app/components/user/login";
import { useRouter, useSearchParams } from "next/navigation";
import useMobileDetect from "@/hooks/useMobileDetect";
import { PersonalInfo } from "@/app/components/user/PersonalInfo";
import userInfoStore from "@/store/userInfoStore";
import shopCartStore from "@/store/shopCartStore";
import useUIStore from '@/store/useUIStore';
import { MiniShoppingCarts } from "@/app/components/miniShoppingCarts";
import { addGtag, changeUrl, isHomePage } from "@/utils/tools";
import Logo from "@/app/assets/common/logo.svg";
import LogoH5 from "@/app/assets/common/logoh5.svg";
import { RecentlyViewtd } from "@/app/components/common/RecentlyViewtd";
import { CardType } from "@/types/index";
import { Event_Name, Login_Click } from "@/service/user/enum";
import { categoryData } from "@/utils/const";
import dynamic from 'next/dynamic';

const Category = dynamic(() => import('@/app/components/layout-widgets/category/index'), {
  loading: () => <h6>Loading...</h6>, // 加载占位符
});
const { Search } = Input;

import "./index.css";

type headerProps = {
  hiddenMobileSearch?: boolean;
  data: CategoryType[];
  isFirst?: boolean,
  isFirstMobile?: boolean
};

type CategoryType = {
  id: string;
  // category: string;
  foreignCategoryName: string;
  // icon: string;
  children?: {
    id: string;
    category?: string;
    foreignCategoryName: string;
    children?: CategoryType[];
    categoryUrl: string;
    icon: string;
  }[];
  categoryUrl: string;
};

export default function Index({
  hiddenMobileSearch = false,
  data,
  isFirst = false,
  isFirstMobile = false,
}: headerProps) {
  const router = useRouter();
  const searchParams = useSearchParams();
  const [showNavigation, setShowNavigation] = useState(false);
  const [showSearch, setShowSearch] = useState(false);

  const [isNextCategory, setIsNextCategory] = useState(false);
  const [nextCategoryIdx, setNextCategoryIdx] = useState(0);
  const [open, setOpen] = useState(false);
  const [openCart, setOpenCart] = useState(false);
  const { userInfo } = userInfoStore();
  const { shopCartInfo, setShopCart } = shopCartStore();
  const [searchTxt, setSearchTxt] = useState(
    searchParams.get("keywords") || "",
  );
  const [isAffix, setIsAffix] = useState(isFirst);
  const isMobile = useMobileDetect(isFirstMobile);
  const { affixStatus, updateAffixStatus } = useUIStore();
  const [isAffixIng, setIsAffixIng] = useState(!isFirst);
  const inputRef = useRef<any>(null);

  useEffect(() => {
    if (isMobile) {
      if (showNavigation || showSearch) {
        document.body.style.overflowY = "hidden";
      } else {
        document.body.style.overflowY = "auto";
      }
    }

    if (!isHomePage()) {
      updateAffixStatus(true);
      setIsAffix(false)
    } else {
      setIsAffix(true)
    }
  }, [showNavigation, showSearch])

  useEffect(() => {
    // setTimeout(() => {
    //   console.log('inputRef : ', inputRef)
    //   if(inputRef) {
    //     console.log('inputRef.current : ', inputRef.current)
    //     inputRef.current.blur();
    //   }
    // }, 200)
  }, [])

  // useEffect(() => {
  //   // 
  //   if(affixStatus) {
  //     setIsAffixIng(affixStatus);
  //   }
  // }, [affixStatus]);

  const isShowAffixIng = useMemo(() => {
    return isAffixIng || affixStatus
  }, [isAffixIng, affixStatus])

  // 监听键盘事件
  const handleKeyDown: React.KeyboardEventHandler<HTMLDivElement> = (event) => {
    if (event.key === 'Enter') {
      // console.log('回车键被按下，当前输入值为:', value);
      // 在这里添加你的逻辑，比如提交表单或触发搜索
      goToSearch();
    }
  };

  const searchWrap = () => {
    return <div className={`${isShowAffixIng ? ' affixIng' : ''}`}>
      <div
        className={`contentMaxWidth`}
        onMouseEnter={() => !isMobile && isHomePage() && updateAffixStatus(true)}
        onMouseLeave={() => !isMobile && isHomePage() && updateAffixStatus(false)}
      >
        <div className="mx-12 flex items-center justify-between py-16 lg:mx-40">
          <div className="flex flex-1 items-center gap-x-10">
            {
              isMobile ?
                showNavigation || showSearch ? (
                  <>
                    <iconpark-icon
                      name="close-big"
                      icon-id="close-big"
                      class="md:hidden"
                      size="2.4rem"
                      color={isShowAffixIng ? "#402C22" : "#fff"}
                      onClick={() => {
                        updateAffixStatus(false);

                        setShowNavigation(false)
                        setIsNextCategory(false);
                        setShowSearch(false);
                      }}
                    />
                    <iconpark-icon
                      icon-id="search"
                      size="2.4rem"
                      name="search"
                      color={isShowAffixIng ? "#402C22" : "#fff"}
                      class="md:hidden"
                    />
                  </>
                ) : (
                  <>
                    <iconpark-icon
                      icon-id="menu"
                      name="menu"
                      class="md:hidden"
                      size="2.4rem"
                      onClick={() => {
                        updateAffixStatus(true);

                        setShowNavigation(true);
                        setIsNextCategory(false);
                      }}
                      color={isShowAffixIng ? "#402C22" : "#fff"}
                    />
                    <iconpark-icon
                      icon-id="search"
                      size="2.4rem"
                      name="search"
                      onClick={() => {
                        updateAffixStatus(true);

                        setShowNavigation(false);
                        setIsNextCategory(false);
                        setShowSearch(true);
                      }}
                      color={isShowAffixIng ? "#402C22" : "#fff"}
                      class="md:hidden"
                    />
                  </>
                )
                :
                null
            }

            <Category data={categoryData} isFirst={isFirst} />
          </div>
          <Link href="/">
            {
              isMobile ?
                <LogoH5 width="27" height="29" fontSize={'1.8rem'} color={isShowAffixIng ? "#402C22" : "#fff"} fill={isShowAffixIng ? "#402C22" : "#fff"} />
                :
                <Logo width="37" height="40" fontSize={'3.2rem'} color={isShowAffixIng ? "#402C22" : "#fff"} fill={isShowAffixIng ? "#402C22" : "#fff"} />
            }
          </Link>
          <div className="flex flex-1 items-center justify-end gap-x-14 md:gap-x-32 cursor-pointer md:w-440">
            <iconpark-icon name="search"
              onClick={() => {
                // updateAffixStatus(true);
                setShowSearch(!showSearch);
              }}
              icon-id="search"
              size="2.6rem"
              class="hidden md:flex"
              color={isShowAffixIng ? "#402C22" : "#fff"}
            />
            <Badge count={shopCartInfo?.count || 0}>
              <iconpark-icon
                name="shopping-cart"
                icon-id="shopping-cart"
                size="2.8rem"
                onClick={() => {
                  setOpenCart(true);
                }}
                color={isShowAffixIng ? "#402C22" : "#fff"}
              />
            </Badge>

            {userInfo?.email ? (
              <PersonalInfo>
                <iconpark-icon
                  className="cursor-pointer"
                  name="user-1"
                  icon-id="user-1"
                  size="2.6rem"
                  color={isShowAffixIng ? "#402C22" : "#fff"}
                  style={isShowAffixIng ? {} : {color: 'transparent', filter: 'brightness(0) invert(1)'}}
                />
              </PersonalInfo>
            ) : (
              <iconpark-icon
                className="cursor-pointer"
                name="user"
                icon-id="user"
                onClick={() => {
                  setOpen(true);
                  addGtag(Event_Name.login_click, {
                    click_position: Login_Click.header_sign_in,
                  })
                }}
                id="signInBtn"
                size="2.6rem"
                color={isShowAffixIng ? "#402C22" : "#fff"}
              />
            )}
          </div>
        </div>
        <div >
          {searchContent()}
        </div>
      </div>
    </div>
  }

  const categoryContent = () =>
    <div style={{ position: "relative" }}>
      {showNavigation ? (
        <div
          style={{
            position: "absolute",
            height: `calc(100vh - ${isShowAffixIng ? '68px' : '100px'})`,
            boxSizing: "border-box",
            top: 0,
            left: 0,
            background: "#F3F2EC",
            width: "100%",
            zIndex: 10,
            overflowY: "auto",
            overflowX: "hidden",
          }}
        >
          <div
            className="flex w-full"
            style={{
              transform: isNextCategory
                ? "translateX(-100vw)"
                : "translateX(0)",
              transition: "all 0.3s linear 0s",
            }}
          >
            <List
              key="1"
              className="navigationH5"
              footer={<div></div>}
              bordered={false}
              dataSource={data}
              renderItem={(item, idx) => (
                <List.Item
                  key={item.id}
                  onClick={(e) => {
                    if(item.children?.length) {
                      setIsNextCategory(true);
                      setNextCategoryIdx(idx);
                      e.stopPropagation();
                      e.preventDefault();
                    }
                  }}
                >
                  <Link
                    target="_blank"
                    href={item.categoryUrl}
                    className="flex w-full items-center justify-between">
                    <h2 className="text-2xl font-medium text-bravve-100 leading-28">
                      {item.foreignCategoryName}
                    </h2>
                    <iconpark-icon icon-id="searchRight" name="right" size="1.8rem" />
                  </Link>
                </List.Item>
              )}
            />
            <div className="w-screen">
              <div
                className="flex w-screen items-center bg-bravve-bg-100 py-16 px-10 cursor-pointer"
                onClick={() => setIsNextCategory(false)}
              >
                <iconpark-icon
                  name="left"
                  icon-id="left"
                  size="1.8rem"
                />
                <span className="text-bravve-100 leading-28 font-medium text-2xl flex-1 text-center">
                  {data[nextCategoryIdx].foreignCategoryName}
                </span>
              </div>

              <List
                key="2"
                className="navigationH5 navigationH5Sub"
                dataSource={data[nextCategoryIdx].children}
                renderItem={(item) => (
                  <List.Item key={item.id}>
                    <List className="noborder navigationH5SubLast w-full">
                      <Link
                        href={changeUrl(item.categoryUrl)}
                        className="flex items-center"
                      >
                        <Image
                          src={item.icon}
                          alt="img"
                          width={64}
                          height={64}
                          className="rounded-xs"
                        />
                        <h3 className="ml-12 leading-22 text-bravve-100">
                          {item.foreignCategoryName}
                        </h3>
                      </Link>
                    </List>
                  </List.Item>
                )}
              />
            </div>
          </div>
        </div>
      ) : null}
    </div>

  const searchContent = () =>
    <div style={{ position: "relative" }} className="affixIng">
      {showSearch ? (
        <div
          style={{
            position: "absolute",
            // height: `calc(100vh - ${isShowAffixIng ? '68px' : '100px'})`,
            boxSizing: "border-box",
            top: 0,
            left: 0,
            background: "#F3F2EC",
            width: "100%",
            zIndex: 10,
            overflowY: "auto",
            overflowX: "hidden",
          }}
          onMouseEnter={() => !isMobile && isHomePage() && updateAffixStatus(true)}
          onMouseLeave={() => {
            if (!isMobile) {
              isHomePage()
              updateAffixStatus(false)
              setShowSearch(false)
            }
          }}
        >
          <div className="relative mx-20 md:mx-40 pt-12 border-b-1 border-bravve-line-100">
            <AutoComplete
              className="autoCompleteSelf"
              onChange={setSearchTxt}
              onKeyDown={handleKeyDown}
              popupClassName="searchAutoCompletePopup"
            >
              <Search
                allowClear={{
                  clearIcon: <iconpark-icon
                    name="close-small"
                    icon-id="close-small"
                    size="3rem"
                    color={"#402C22"}
                  />
                }}
                ref={inputRef}
                // size="large"
                className="search-input"
                placeholder="What can we help you find?"
                enterButton={<iconpark-icon
                  name="search"
                  onClick={goToSearch}
                  icon-id="search"
                  size="2.4rem"
                  color={"#402C22"}
                />}
              />
            </AutoComplete>
          </div>

          <div className="my-40"><RecentlyViewtd type={2} /></div>
        </div>
      ) : null}
    </div>

  const goToSearch = () => {
    if (!searchTxt.trim()) {
      return;
    }
    setShowNavigation(false)
    setIsNextCategory(false);
    setShowSearch(false);
    router.push("/search?keywords=" + searchTxt)
    inputRef.current.blur()
  }

  return (
    <>
      <div className="search-column text-bravve-100 cardItem" data-card-idx={1} data-card-type={CardType.PAGE_HEADER}>
        <div
          className="cardItemContent"
          data-content-id={isMobile ? 'mobile' + CardType.PAGE_HEADER : 'pc' + CardType.PAGE_HEADER}
          data-content-name={'pageheader'}
          data-content-position={1}
        >
          {
            isAffix ?
              <Affix
                target={() => document.body}
                onChange={(val?: boolean) => {
                  val !== undefined && setIsAffixIng(val)
                }}
              >
                <div>
                  {searchWrap()}
                  {categoryContent()}
                  {/* {
                    searchContent()
                  } */}
                </div>
              </Affix>
              :
              <div>
                {
                  searchWrap()
                }
                {
                  categoryContent()
                }
                {/* {
                  searchContent()
                } */}
              </div>
          }
        </div>
        {/* {!hiddenMobileSearch && (
          <div className="px-12 pb-16 md:hidden">
            <Input
              className="search-input"
              placeholder="Search Crazy-Good Deals"
              allowClear={{ clearIcon: <CloseSmall size={"2.4rem"} /> }}
              value={searchTxt}
              prefix={
                <iconpark-icon name="search" icon-id="search" size="1.8rem" class="mr-5" />
              }
              onChange={(e) => setSearchTxt(e.target.value)}
              onPressEnter={(e) =>
                router.push("/search?keywords=" + searchTxt)
              }
              maxLength={200}
            />
          </div>
        )} */}
      </div>
      <Login open={open} onClose={() => setOpen(false)} />
      <MiniShoppingCarts
        open={shopCartInfo.isNew || openCart}
        onSignIn={() => {
          setOpenCart(false);
          setOpen(true);
        }}
        onClose={() => {
          // console.log("close", shopCartInfo.isNew);
          setOpenCart(false);
          setShopCart({ isNew: false });
        }}
      />
    </>
  );
}
